import styled from 'styled-components'
import PropTypes from 'prop-types'
import { t, jt } from 'ttag'
import { useDispatch } from 'react-redux'

import { features } from '@h2/components/media'
import { PG } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Heading as HeadingComponent } from '@h2/components/typography/heading'
import { PromoButton } from '@h2/components/buttons/promo'
import { Panel as PanelComponent } from '@h2/common/components/panel'
import { openSigninDialog } from '@main/actions/signinOrRegisterDialog'

const startedToday = <span key="started">{t`started today`}</span>
const free = <span key="free">{t`free`}</span>
const Heading = styled(HeadingComponent)`
  font-size: 45px;
  line-height: 44px;

  span {
    font-weight: 400;
  }
`
const Panel = styled(PanelComponent)`
  display: none;

  @media (${features.minWidth.desktop}) {
    display: block;

    @media (${features.maxWidth.widescreen}) {
      ${Heading} {
        font-size: 42px;
      }
    }
  }
`
const GetStartedToday = ({ tenantId }) => {
  const dispatch = useDispatch()

  return (
    <Panel color={/california/.test(tenantId) ? '#225FDE' : PG}>
      <Flex py="48px">
        <Box>
          <Heading level="2" weight="light" color="white" mark="span" removeMargins>
            {jt`Get ${startedToday} with a ${free} account`}
          </Heading>
        </Box>
        <Box margin="0 0 0 45px" grow={1}>
          <PromoButton
            isFullWidth
            size="large"
            align="center"
            variant="larger-text"
            onClick={() => dispatch(openSigninDialog('createAccount'))}>
            {t`Create a free account`}
          </PromoButton>
        </Box>
      </Flex>
    </Panel>
  )
}

GetStartedToday.propTypes = {
  tenantId: PropTypes.string.isRequired
}

export { GetStartedToday }
